export function labelsToSelectOptions<T extends string>(
  labels: Record<T, string>
): { key: string; name: string }[] {
  return [
    { key: "", name: "選択なし" },
    ...(Object.keys(labels) as T[]).map(k => ({ key: k, name: labels[k] }))
  ];
}

export function generateNewSchoolId(existIds: string[], order = 1): string {
  const newId = order.toString().padStart(6, "0");
  if (existIds.includes(newId)) {
    return generateNewSchoolId(existIds, order + 1);
  } else {
    return newId;
  }
}
